export interface NotificationFeatureState {}

export const initialState: NotificationFeatureState = {};
